// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  useEffect,
  useRef,
} from 'react'

// NOTE - callback should not be an anonymous function.
// that will cause the useEffect [callback] to consider it to be a new function on every pass.
// this unnecessarily clears and sets the interval every time but also makes the delay time
// all the less precise.

// NOTE - takes a callback and a delay.
// if the delay is not null, then a setInterval is set up.
// whenever the callback or the delay change,
// the current setInterval is cleared out and a new setInterval
// is created based on the current callback and delay values

const useInterval = (callback, delay) => {
  const intervalId = useRef(null)

  const endInterval = () => {
    clearInterval(intervalId.current)
    intervalId.current = null
  }

  // tracks callback value, allowing this to change
  useEffect(() => {
    // if there is an ongoing interval, then clear it out
    if (intervalId.current !== null) {
      endInterval()
    }

    if (delay !== null) {
      intervalId.current = setInterval(callback, delay)
    }

    return endInterval
  }, [callback, delay])
}

export default useInterval
